__turbopack_context__.v({
  "className": "permanent_marker_9750d39e-module__7mnDMq__className",
});
